import type { CBrowserPressOnlineTranslations } from "./pl";

/**
 * CBrowserPressOnline - English translations (Online press browser -
 * issue list + issue view with pages clickable into a lightbox).
 */
export const en: CBrowserPressOnlineTranslations = {
  emptyData: "No data to display.",
  emptyList: "No issues to display.",
  emptyIssue: "This issue has no pages yet.",
  backToList: "<- Back to issue list",
  openPage: "Open page",
  download: "Download",
  offer: "See the entire offer",
  newsletter: "Order the newsletter",
  applies: "Valid",
  from: "from",
  to: "to",
  /** `pagesCount(5)` -> "5 pages". */
  pagesCount: (n: number): string => `${n} ${n === 1 ? "page" : "pages"}`,
  /** `pageLabel(3)` -> "Page 3". */
  pageLabel: (n: number) => `Page ${n}`,
  formatDate: (iso: string): string => {
    const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return iso;
    return `${m[3]}/${m[2]}/${m[1]}`;
  },
};
